import React from 'react';
import { SearchIcon, XIcon } from 'lucide-react';
import type { ChannelFilter } from '../../types/ui';
interface TimelineToolbarProps {
  filter: ChannelFilter;
  counts: Record<ChannelFilter, number>;
  query: string;
  onFilterChange: (filter: ChannelFilter) => void;
  onQueryChange: (query: string) => void;
}
const FILTERS: {
  value: ChannelFilter;
  label: string;
}[] = [{
  value: 'all',
  label: 'All'
}, {
  value: 'call',
  label: 'Calls'
}, {
  value: 'sms',
  label: 'Texts'
}, {
  value: 'email',
  label: 'Emails'
}, {
  value: 'event',
  label: 'Events'
}];
export function TimelineToolbar({
  filter,
  counts,
  query,
  onFilterChange,
  onQueryChange
}: TimelineToolbarProps) {
  return <div className="flex flex-col gap-3 border-b border-line px-6 py-3 md:flex-row md:items-center md:justify-between" data-id="element-87" data-mp="1fpl8o0b372hk">
      <div role="tablist" aria-label="Filter activity by channel" className="flex min-w-0 flex-1 items-center gap-1 overflow-x-auto" data-id="element-88" data-mp="2w3bi7mkz6iyl">
        {FILTERS.map(({
        value,
        label
      }) => {
        const active = filter === value;
        return <button key={value} role="tab" type="button" aria-selected={active} onClick={() => onFilterChange(value)} className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-md px-2.5 py-1.5 font-display text-[12.5px] transition-colors duration-150 ease-emphasis focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-accent ${active ? 'bg-accent font-bold text-white' : 'font-semibold text-ink-muted hover:bg-surface-muted hover:text-ink'}`} data-id="element-89" data-mp="ggl43eoo7jbo">
              {label}
              <span className={`tabular-nums text-[11.5px] ${active ? 'text-gold' : 'text-ink-subtle'}`} data-id="element-90" data-mp="366oeia9sgmli">
                {counts[value]}
              </span>
            </button>;
      })}
      </div>

      <div className="flex items-center" data-id="element-91" data-mp="332h0n50g8142">
        <div className="relative flex-1 md:w-52 md:flex-none lg:w-60" data-id="element-92" data-mp="2y6idtlurqr5r">
          <SearchIcon className="pointer-events-none absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-subtle" data-id="element-93" data-mp="3cudateft7hon" />
          <input type="search" value={query} onChange={event => onQueryChange(event.target.value)} placeholder="Search activity" aria-label="Search activity" className="w-full rounded-md border border-line bg-surface-muted py-1.5 pl-8 pr-8 text-[13px] text-ink placeholder:text-ink-subtle focus:border-accent focus:bg-surface focus:outline-none" data-id="element-94" data-mp="37va4zrs097fm" />
          {query && <button type="button" onClick={() => onQueryChange('')} aria-label="Clear search" className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-0.5 text-ink-subtle transition-colors duration-100 ease-emphasis hover:text-ink" data-id="element-95" data-mp="2p7exuqqwervh">
              <XIcon className="h-3.5 w-3.5" data-id="element-96" data-mp="gxffqyy2tf3v" />
            </button>}
        </div>
      </div>
    </div>;
}